<template>
  <div class="relative bg-white isolate overflow-hidden">
    <section class="py-4 mx-auto">
      <div class="mx-auto">
        <div class="items-center justify-center grid lg:flex grid-cols-3 md:grid-cols-4 sm:gap-y-16">
          <div v-for="(brand, index) in brands" :key="index">
            <img class="object-contain px-4 w-auto mx-auto h-16 " :src="brand.url" :alt="brand.alt" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Brands",
  props: {
    brands: {
      type: Array,
      required: true
    }
  }
};
</script>
